import React, { Component } from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import { BeatLoader } from "react-spinners";
import NotCompleted from "../../img/donuts/not-completed.svg";
import { NavLink } from "react-router-dom";
import LoaderAssessSelectorBar from '../../components/Assessment/AssessSelectorBar/LoaderAssessSelectorBar'

// use these imports for testing
import districtAdmin from "../../helpers/users/testing/districtAdmin";

// on the '/assessment/dashboard/' route
class LoaderAssessmentDashboardContainer extends Component {
  constructor(props) {
    super(props);

    // change this to change default user in devMode

    this.state = {
     
      user: districtAdmin
     
    };
  }

  // Initializes assessment data

  render() {
    const xs = 12;
    const sm = 12;
    const md = 12;
    const lg = 12;
    const xl = 12;
    const {user} = this.props;
    const selectHeaderStye = {
      display: 'flex',
    flexWrap: 'wrap',
    marginTop: '-21px',
    
    }
    return (
      <div>
      
         {user.role !== 'Student' &&
          <div style={selectHeaderStye}>
         <LoaderAssessSelectorBar
            
          /></div>
        }
        <Row>
        <Col {...{ xs, sm, md, lg, xl }}>
          <Card className="top-card">
            <CardBody>
              <Row>
                <Col xs="12" lg="4" className="test-progress">
                  <div className="loading-animation">
                    <BeatLoader loading={true} color={"#00C1AB"} />
                  </div>
                </Col>
                {/* Composite Donut in Top Card */}
                <Col
                  className="top-card-donut-chart-container"
                  xs="12"
                  lg="8"
                  xl="8"
                >
                  <Row>
                    <Col
                      xs="12"
                      sm="5"
                      md="4"
                      lg="5"
                      xl="3"
                      className="composite-donut"
                    >
                      <div className="donut-chart composite composite-loader">
                        <div className="loading-animation">
                          <div className="donut-loader">
                            <div className="css-6fyzox" />
                            <div className="css-1dhe946" />
                            <div className="css-6fyzox" />
                          </div>
                        </div>
                      </div>
                    </Col>

                    <Col
                      xs="12"
                      sm="7"
                      md="8"
                      lg="7"
                      xl="9"
                      className="subject-donuts"
                    >
                      <Row>
                        <Col xs="6" md="3" lg="6" xl="3">
                          <div className="donut-chart english english-loader">
                            <div className="loading-animation">
                              <div className="donut-loader">
                                <div className="css-6fyzox" />
                                <div className="css-1dhe946" />
                                <div className="css-6fyzox" />
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col xs="6" md="3" lg="6" xl="3">
                          <div className="donut-chart english english-loader">
                            <div className="loading-animation">
                              <div className="donut-loader">
                                <div className="css-6fyzox" />
                                <div className="css-1dhe946" />
                                <div className="css-6fyzox" />
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col xs="6" md="3" lg="6" xl="3">
                          <div className="donut-chart english english-loader">
                            <div className="loading-animation">
                              <div className="donut-loader">
                                <div className="css-6fyzox" />
                                <div className="css-1dhe946" />
                                <div className="css-6fyzox" />
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col xs="6" md="3" lg="6" xl="3">
                          <div className="donut-chart english english-loader">
                            <div className="loading-animation">
                              <div className="donut-loader">
                                <div className="css-6fyzox" />
                                <div className="css-1dhe946" />
                                <div className="css-6fyzox" />
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>

            <Row className="report-view-links" noGutters>
              <Col xs="12" md="4">
                <NavLink className="report-link overview-report" to="/">
                  Overview
                </NavLink>
              </Col>
              <Col xs="12" md="4">
                <NavLink className="report-link skill-report" to="/">
                  Skill Report
                </NavLink>
              </Col>
              <Col xs="12" md="4">
                <NavLink className="report-link item-report" to="/">
                  Item Report
                </NavLink>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col xl="3" md="6" sm="12" lg="6">
          <Card className="assessment-overview-by-subject rounded-top">
            <Row
              className="assessment-overview-by-subject__title-container rounded-top"
              noGutters
            >
              <Col xs="12">
                <h3 className="title">English</h3>
              </Col>
            </Row>
            <CardBody>
              <Row>
                <Col xs="12">
                  <div>
                    <div className="donut-chart english english-loader">
                      <div className="loading-animation">
                        <div className="donut-loader">
                          <div className="css-6fyzox" />
                          <div className="css-1dhe946" />
                          <div className="css-6fyzox" />
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>

        <Col xl="3" md="6" sm="12" lg="6">
          <Card className="assessment-overview-by-subject rounded-top">
            <Row
              className="assessment-overview-by-subject__title-container rounded-top"
              noGutters
            >
              <Col xs="12">
                <h3 className="title">Math</h3>
              </Col>
            </Row>
            <CardBody>
              <Row>
                <Col xs="12">
                  <div>
                    <div className="donut-chart english english-loader">
                      <div className="loading-animation">
                        <div className="donut-loader">
                          <div className="css-6fyzox" />
                          <div className="css-1dhe946" />
                          <div className="css-6fyzox" />
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>

        <Col xl="3" md="6" sm="12" lg="6">
          <Card className="assessment-overview-by-subject rounded-top">
            <Row
              className="assessment-overview-by-subject__title-container rounded-top"
              noGutters
            >
              <Col xs="12">
                <h3 className="title">Reading</h3>
              </Col>
            </Row>
            <CardBody>
              <Row>
                <Col xs="12">
                  <div>
                    <div className="donut-chart english english-loader">
                      <div className="loading-animation">
                        <div className="donut-loader">
                          <div className="css-6fyzox" />
                          <div className="css-1dhe946" />
                          <div className="css-6fyzox" />
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>

        <Col xl="3" md="6" sm="12" lg="6">
          <Card className="assessment-overview-by-subject rounded-top">
            <Row
              className="assessment-overview-by-subject__title-container rounded-top"
              noGutters
            >
              <Col xs="12">
                <h3 className="title">Science</h3>
              </Col>
            </Row>
            <CardBody>
              <Row>
                <Col xs="12">
                  <div>
                    <div className="donut-chart english english-loader">
                      <div className="loading-animation">
                        <div className="donut-loader">
                          <div className="css-6fyzox" />
                          <div className="css-1dhe946" />
                          <div className="css-6fyzox" />
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      </div>
    );
  }
}

export default LoaderAssessmentDashboardContainer;



// WEBPACK FOOTER //
// ./src/containers/Assessment/LoaderAssessmentDashboardContainer.js